import { getMe } from './me'

// The first-time guide for Extra features (Liam 2 Oct 2026: "There's no animations to guide us through this the 1st
// time"). The same glow as the prices set-up and the first-booking guide (styles.css guide-glow), one step at a time:
//   1. the Extra features card on Your business glows twice, the first time it is opened;
//   2. on Extra features, the switch glows until it is used;
//   3. once several jobs is on, one hint ("Now open a customer and tap Add another job") until
//   4. the first customer page opened after that, where "Add another job" glows.
// Each shows once per owner per phone. Kept in this phone's storage; a private window that refuses it shows each step
// for this visit only, never an error.

export type GuideStep = 'business-card' | 'switch' | 'switched-on' | 'add-job'

const key = (step: GuideStep): string => {
  const me = getMe()
  return `roundly:extra-features-guide:${step}:${me?.businessId ?? 'none'}:${me?.email ?? ''}`
}
const thisVisit = new Set<string>()

export function guideSeen(step: GuideStep): boolean {
  const k = key(step)
  if (thisVisit.has(k)) return true
  try {
    return localStorage.getItem(k) === '1'
  } catch {
    return false
  }
}

export function markGuideSeen(step: GuideStep): void {
  const k = key(step)
  thisVisit.add(k)
  try {
    localStorage.setItem(k, '1')
  } catch {
    // Private window: remembered for this visit only.
  }
}

// After switching on, until the owner has been shown "Add another job" on a customer.
export function addJobHintDue(): boolean {
  return guideSeen('switched-on') && !guideSeen('add-job')
}

// The first "Add another job" drawn after switching on glows, once.
export function glowAddJobOnce(button: HTMLElement): void {
  if (!addJobHintDue()) return
  button.classList.add('first-visit-glow')
  markGuideSeen('add-job')
}
